import React from 'react'
import {  RouterProvider } from 'react-router-dom'
import router from './routes'
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from 'react-toastify';

export default function App() {
  return (
    <div style={{paddingBottom:"0px"}} >
  <ToastContainer/>      
      <RouterProvider router={router} />
    </div>
  )
}
